<template>
  <div class="container tenant-profile">
    <TenantProfileMenu />

    <form ref="tenantForm">

      <div class="grey-box-container clearfix">

        <h2>Company Account Status</h2>

        <div class="text">
          <fieldset v-if="$store.state.tenant.status === 'DRAFT'">
            <p>
              The company status is currently <strong>DRAFT</strong>. It means that the website is not yet publicly visible,
              until you have entered the company information and you have activated it. You probably want also to tweak the customization
              options, like adding a company logo, before publishing.
            </p>
            <p>
              Your public company website address will be:<br/>
              <strong>{{ tenantDomain() }}</strong>
            </p>
            <div>
              <button @click.prevent="activateCompany">Activate company account</button>
            </div>
          </fieldset>

          <fieldset v-else-if="$store.state.tenant.status === 'ACTIVE'">
            <p>
              The company status is active. The website is publicly visible.
            </p>
            <p>
              Your public company website address is:<br/>
              <strong>{{ tenantDomain() }}</strong>
            </p>
          </fieldset>

          <fieldset v-else-if="$store.state.tenant.status === 'SUSPENDED'">
            <p>
              The company status is currently still <strong>SUSPENDED</strong>.
              It means that the website is not publicly available. Only the company administrators can access
              the company sections.
            </p>
            <p>
              Please contact PFX personnel in you wish to re-activate the company account,
              or if you have any other questions.
            </p>
            <p>
              <a :href="'mailto:' + supportEmail">{{ supportEmail }}</a>
            </p>
          </fieldset>

          <fieldset v-else-if="$store.state.tenant.status === 'DELETED'">
            <p>
              The company status is currently still <strong>DELETED</strong>.
              It means that the website is not publicly available.
            </p>
            <p>
              Please contact PFX personnel in you wish to re-activate the company account,
              or if you have any other questions.
            </p>
            <p>
              <a :href="'mailto:' + supportEmail">{{ supportEmail }}</a>
            </p>
          </fieldset>

          <fieldset v-else>
            Unknown status: {{ $store.state.tenant.status }}
          </fieldset>
        </div>

      </div>

    </form>

  </div>
</template>

<script>
  import TenantProfileMenu from './TenantProfileMenu.vue'

  export default {
    name: 'TenantProfile',
    components: {
      TenantProfileMenu
    },
    data() {
      return {
        supportEmail: process.env.config.frontend.supportEmail
      }
    },
    created() {
      this.refetchTenantStatus()
    },
    methods: {
      tenantDomain() {
        const pfxLandingPageUrl = process.env.config.frontend.pfxLandingPage
        const subdomain = this.$store.state.tenant.subdomain
        return pfxLandingPageUrl.replace(/\/\//, '//' + subdomain + '.')
      },

      activateCompany() {
        this.$store.commit('setLoadingSpinner', true)
        const subdomain = this.$store.state.tenant.subdomain
        this.$PfxBackendApi.setTenantStatus(subdomain, 'ACTIVE')
          .then(res => {
            console.log('setTenantStatus res', res)
            this.refetchTenantStatus()
          })
          .catch(err => {
            console.error('setTenantStatus err', err)
            this.$store.commit('openDialog', {
              text: 'Failed to activate the company account',
              buttons: [{ title: 'Close' }]
            })
          })
          .then(() => {
            this.$store.commit('setLoadingSpinner', false)
          })
      },

      refetchTenantStatus() {
        const subdomain = this.$store.state.tenant.subdomain
        this.$store.commit('setLoadingSpinner', true)
        this.$PfxBackendApi.getTenantStatus(subdomain).then(res => {
          console.log('getTenantStatus', res)
          this.$store.commit('setTenantStatus', res.data.status)
        }).catch(err => {
          console.error('getTenantStatus failed', err)
        }).then(() => {
          this.$store.commit('setLoadingSpinner', false)
        })
      }

    }
  }
</script>

<style lang="scss">

  @import '../pfx.scss';

  .text {
    @include stack();
    @include tablet-landscape-breakpoint {
      @include column(2/3)
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/TenantActivate.vue